import { apiRequest } from './client'

export type PageAdPage =
  | 'home'
  | 'works_square'
  | 'contests'
  | 'marketplace'
  | 'tasks'
  | 'studio'
  | 'account'
  | 'subscription'

export type PageAdLayout = 'fullscreen' | 'row_1' | 'row_2' | 'row_4'

export interface PageAdItem {
  id: number
  page: PageAdPage
  layout: PageAdLayout
  title: string
  image_url: string
  link_url: string
  sort_order: number
  enabled: boolean
}

export interface PageAdLayoutGroup {
  layout: PageAdLayout
  items: PageAdItem[]
}

export interface PageAdsPublicView {
  page: PageAdPage
  groups: PageAdLayoutGroup[]
}

export const pageAdsApi = {
  list: (page: PageAdPage) =>
    apiRequest<PageAdsPublicView>('/api/v1/page-ads', { query: { page }, auth: false }),
}
